function omit<T extends object, K extends keyof T>(
  obj: T,
  props: K[] = []
): Omit<T, K> {
  obj = { ...obj };
  props.forEach((prop) => delete obj[prop]);

  return obj;
}

function omitBy<T extends object>(obj: T, check: (value: any) => boolean): T {
  obj = { ...obj };
  Object.entries(obj).forEach(([key, value]) => {
    check(value) && delete obj[key as keyof T];
  });

  return obj;
}

export { omit, omitBy };
